// extracted by mini-css-extract-plugin
export default {"productGrid":"NY-z","centerLink":"OY-z","productSection":"PY-z","item":"QY-z","ctaButton":"RY-z"};